export enum FnAntModalWidth {
  Sm = 500,
  Mg = 620,
  Lg = 880,
  Xl = 1299
}

export enum Variants {
  Primary = 'primaryVariant',
  Danger = 'dangerVariant'
}
